import axios from "axios";

export default {
    namespaced: true,
    state: {
        list: {},
    },
    getters: {
        all: state => state.list,
        isPreloaded: state => (url, params) => {
            url = window.location.origin + axios.getUri({ url, params });
            return state.list[url] instanceof Promise;
        },
    },
    mutations: {
        preload(state, list) {
            list.forEach(url => {
                url = axios.getUri({url});
                makePreloadPromise(state, { url, cache: true });
            });
        },
    },
    actions: {
        preload({ state, commit }, { url, params = {}, cache }) {
            url = window.location.origin + axios.getUri({ url, params });

            if (!cache) {
                return new Promise((resolve, reject) => {
                    axios.get(url).then((response) => resolve(response.data.data)).catch(reject);
                });
            }

            commit('preload', [url]);
            return state.list[url];
        },

        loadData({ sate, commit }, { url, params = {} }) {
            Object.assign(params, { formdata: 1 });
            url = window.location.origin + axios.getUri({ url, params });
            return new Promise((resolve, reject) => {
                axios.get(url).then((response) => {
                    resolve(response.data.data);
                }).catch(reject);
            });
        }
    },
}

function makePreloadPromise(state, { url, cache }) {
    if (state.list[url] instanceof Promise) return state.list[url];
    state.list[url] = new Promise((resolve, reject) => {
        return axios.get(url).then((response) => {
            if (cache) {
                state.list[url] = new Promise((resolve) => resolve(response.data.data));
            }
            resolve(response.data.data);
        }).catch(() => {
            state.list[url] = null;
            reject();
        });
    });
}
